import { ref, readonly, computed } from 'vue';
import { Transcription } from '@/api/openapi';
import { TranscriptionApiService } from '@/api/user/resources/transcription';
import { add, isDateAfter } from '@/utils/date-time';

const useTranscription = () => {
  const api = new TranscriptionApiService();
  const transcription = ref<Transcription>();
  const transcriptionExists = computed(() => {
    return transcription.value?.id != null;
  });
  const isTranscriptionResultEmpty = computed(() => {
    return !transcription.value?.mergedTexts?.length;
  });
  const transcriptionFailed = computed(() => {
    return transcription.value?.processingStatus === 'failed';
  });
  const transcriptionInProgress = computed(() => {
    return transcription.value?.processingStatus === 'processing' || transcription.value?.processingStatus === 'not_started';
  });
  const rightAfterTranscription = computed(() => {
    if (transcriptionFailed.value) return false;
    // NOTE: 文字起こし後すぐ（30秒間）（要約の取得を待機するかどうかの判定で使用）
    // リロード間隔と合わせてある（リロード間隔は src/components/organisms/user/transcription/SidePanel.vue 以下に定義）
    return !isDateAfter(new Date(), add(transcription.value?.createdAt, 30, 'second'));
  });

  const fetchTranscription = async (callResultId: number) => {
    const res = await api.getTranscription({
      request: { callResultId },
      errorHandlers: {
        404: () => {
          transcription.value = undefined;
        },
      },
    });
    transcription.value = res.data.transcription;
  };

  return {
    transcription: readonly(transcription),
    fetchTranscription,
    transcriptionExists,
    isTranscriptionResultEmpty,
    transcriptionInProgress,
    rightAfterTranscription,
  };
};

export {
  useTranscription,
};
